import $store from 'domovio-core/src/system/store';
import Config from 'domovio-core/src/system/config';

// ROUTERS
import DefaultRouter from './DefaultRouter';
import DetailRouter from './DetailRouter';

// VIEWS
const DefaultView = () => import('../views/DefaultView');
const DetailView = () => import( '../views/DetailView');

// MODULES
import OptionRouter from '../modules/OptionModule/router/router';
import ExtensionRouter from '../modules/ExtensionModule/router/router';
import UnitRouter from '../modules/UnitModule/router/router';
import CustomerRouter from '../modules/CustomerModule/router/router';
import SiteRouter from '../modules/SiteModule/router/router';

export default {
    path:      '/projects',
    component: DefaultRouter,
    async beforeEnter(to, from, next) {
        await $store.dispatch('user/init');
        if ($store.getters['user/isLoggedIn']) next();
        else window.location.href = Config.APP_DOMAIN;
    },
    children:  [
        {
            path:      '',
            name:      'project-default',
            component: DefaultView,
        }, {
            path:      'p/:projectId',
            component: DetailRouter,
            children:  [
                {
                    path:      '',
                    name:      'project-detail',
                    component: DetailView,
                },
                ...OptionRouter,
                ...UnitRouter,
                ...CustomerRouter,
                ...ExtensionRouter,
                ...SiteRouter
            ]
        }
    ]
}
